import { HttpContextToken } from '@angular/common/http';

export const NO_AUTH = new HttpContextToken(() => false);

/** When set to true on an HTTP request, the ErrorInterceptor will not display error toasts for that request. */
export const SILENT_ERROR = new HttpContextToken(() => false);